import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Bookmark from './Bookmark';
import { useQueryMutation } from '../../hooks/@lore/query-connect';
import { useQueryClient } from '@tanstack/react-query';
import classNames from 'classnames';

StoryBookmark.propTypes = {
  user: PropTypes.object.isRequired,
  story: PropTypes.object
};

export default function StoryBookmark(props) {
  const { user, story } = props;

  const storyBookmark = useConnect('bookmark.first', {
    where: {
      eager: {
        $where: {
          creatorId: user.id,
          storyId: story.id
        }
      }
    }
  });

  const queryClient = useQueryClient();
  const mutation_create = useQueryMutation('bookmark.create');
  const mutation_destroy = useQueryMutation('bookmark.destroy', storyBookmark);

  const isLoading = (
    mutation_create.isLoading ||
    mutation_destroy.isLoading
  );

  function onBookmark() {
    mutation_create.mutate({
      creatorId: user.id,
      storyId: story.id
    }, {
      onSuccess: function(_data) {
        storyBookmark._removeQuery();
        queryClient.invalidateQueries({ queryKey: ['bookmark'] });
      }
    });
  }

  function onRemoveBookmark() {
    mutation_destroy.mutate(null, {
      onSuccess: function(_data) {
        storyBookmark._removeQuery();
        queryClient.invalidateQueries({ queryKey: ['bookmark'] });
      }
    });
  }

  if (storyBookmark.state === PayloadStates.FETCHING) {
    return (
      <Bookmark
        className="opacity-70"
        tooltip="Fetching status..."
      />
    );
  }

  if (
    storyBookmark.state === PayloadStates.NOT_FOUND ||
    storyBookmark.state === PayloadStates.DELETED
  ) {
    return (
      <Bookmark
        className={classNames(
          isLoading && 'opacity-70'
        )}
        onClick={isLoading ? () => {} : onBookmark}
        tooltip="Bookmark story"
      />
    );
  }

  return (
    <Bookmark
      className={classNames(
        isLoading && 'opacity-70'
      )}
      selected={true}
      onClick={isLoading ? () => {} : onRemoveBookmark}
      tooltip="Remove bookmark"
    />
  );
}
